(function () {
  function init() {
    const config = window.dermaStampNoticeConfig;
    if (!config || !config.enabled) return;

    const CHECKOUT_SELECTOR_LIST = [
      'button[name="checkout"]',
      '.cart__checkout-button',
      'a[href*="/checkout"]',
      '[data-checkout]',
      '.cart__checkout',
      '.checkout-button',
      '.upcart-checkout-button',
      '.upcart-cart .checkout-button',
      '.upcart-cart .upcart-checkout-button',
      '[class*="upcart"][class*="checkout"]',
      '#CartDrawer-Checkout button',
      '#CartDrawer-Checkout a',
    ];

    let pendingCheckout = null;
    let cartIsRelevantCache = null;
    let cartFetchPromise = null;
    let upcartCheckoutHandled = false;

    function isActive() {
      if (!config.endDate) return true;
      return Date.now() < new Date(config.endDate).getTime();
    }

    function packagingNoticeWillHandleCheckout() {
      const packagingConfig = window.packagingNoticeConfig;
      if (!packagingConfig || !packagingConfig.enabled) return false;
      if (packagingConfig.endDate && Date.now() >= new Date(packagingConfig.endDate).getTime()) {
        return false;
      }
      return true;
    }

    function isCheckoutText(text) {
      return /\b(checkout|check out|secure checkout)\b/i.test(text || '');
    }

    function isInsideDermaModal(node) {
      return !!(node.closest && node.closest('#DermaStampNoticeModal'));
    }

    function isUpcartCheckoutNode(node) {
      if (!(node instanceof Element)) return false;
      const root = node.closest('[class*="upcart"]');
      if (!root) return false;

      const button = node.closest('button, a, [role="button"]');
      if (!button || isInsideDermaModal(button)) return false;

      if (button.matches(CHECKOUT_SELECTOR_LIST.join(','))) return true;
      const href = button.getAttribute('href');
      if (href && href.includes('/checkout')) return true;
      if (isCheckoutText(button.textContent)) return true;

      return false;
    }

    function getCheckoutTriggerFromPath(path) {
      for (const node of path) {
        if (!(node instanceof Element)) continue;
        if (isInsideDermaModal(node)) continue;

        if (node.matches && node.matches(CHECKOUT_SELECTOR_LIST.join(','))) {
          return node;
        }

        const matched = node.closest && node.closest(CHECKOUT_SELECTOR_LIST.join(','));
        if (matched) return matched;

        if (isUpcartCheckoutNode(node)) {
          return node.closest('button, a, [role="button"]');
        }
      }

      return null;
    }

    function getCheckoutTrigger(event) {
      const path = (event.composedPath ? event.composedPath() : null) || [event.target];
      return getCheckoutTriggerFromPath(path);
    }

    function closeAllCartDrawers() {
      if (typeof window.upcartCloseCart === 'function') {
        window.upcartCloseCart();
      }

      document.querySelectorAll('cart-drawer').forEach((drawer) => {
        if (typeof drawer.close === 'function') {
          drawer.close();
        } else {
          drawer.classList.remove('active', 'animate');
        }
      });

      document.body.classList.remove('icart-drawer-open', 'overflow-hidden');
      document.documentElement.classList.remove('overflow-hidden');

      document.body.classList.forEach((className) => {
        if (className.indexOf('overflow-hidden-') === 0) {
          document.body.classList.remove(className);
        }
      });

      ['overflow', 'position', 'top', 'width'].forEach((property) => {
        document.body.style.removeProperty(property);
        document.documentElement.style.removeProperty(property);
      });

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus();
      }
    }

    function fetchCart() {
      if (!cartFetchPromise) {
        cartFetchPromise = fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        })
          .then((response) => response.json())
          .finally(() => {
            cartFetchPromise = null;
          });
      }

      return cartFetchPromise;
    }

    function itemIsSerum(item) {
      const handle = String(item.handle || item.product_handle || '').toLowerCase();
      const title = String(
        item.product_title || item.title || item.name || '',
      ).toLowerCase();
      const sku = String(item.sku || '').toLowerCase();
      const productType = String(item.product_type || '').toLowerCase();
      const productId = String(item.product_id || item.productId || '');
      const variantId = String(item.variant_id || item.variantId || '');
      const serumProductIds = (config.serumProductIds || []).filter(Boolean);
      const serumVariantIds = (config.serumVariantIds || []).filter(Boolean);
      const serumSkus = (config.serumSkus || []).filter(Boolean);

      if (serumProductIds.includes(productId)) return true;
      if (serumVariantIds.includes(variantId)) return true;

      if (
        serumSkus.some((value) => {
          const normalized = String(value).toLowerCase();
          return normalized && sku === normalized;
        })
      ) {
        return true;
      }

      if (
        (config.serumHandles || []).some((value) => {
          const normalized = String(value).toLowerCase();
          return normalized && (handle === normalized || handle.includes(normalized));
        })
      ) {
        return true;
      }

      if (handle.includes('serum') || title.includes('serum')) return true;
      if (productType.includes('serum')) return true;

      return false;
    }

    function itemIsDermaStamp(item) {
      const handle = String(item.handle || item.product_handle || '').toLowerCase();
      const sku = String(item.sku || '').toLowerCase();
      const productId = String(item.product_id || item.productId || '');
      const variantId = String(item.variant_id || item.variantId || '');
      const dermaHandle = String(config.dermaStampHandle || '').toLowerCase();
      const dermaSku = String(config.dermaStampSku || '').toLowerCase();
      const dermaVariantId = String(config.dermaStampVariantId || '');
      const dermaProductId = String(config.dermaStampProductId || '');

      if (dermaProductId && productId === dermaProductId) return true;
      if (dermaVariantId && variantId === dermaVariantId) return true;
      if (dermaSku && sku === dermaSku) return true;
      if (dermaHandle && (handle === dermaHandle || handle.includes('derma-stamp'))) {
        return true;
      }

      return false;
    }

    function cartHasSubscription(cart) {
      return (cart.items || []).some(function (item) {
        return !!(
          item.selling_plan_allocation ||
          item.sellingPlanAllocation ||
          (item.properties && item.properties.selling_plan)
        );
      });
    }

    /* Who this modal is for.

       The stamp is a subscription gift: global.js only injects the ships-now
       gift ids when the variant box reports data-subscription-product="true",
       so a one-time serum buyer never receives one and has no second delivery
       for it to arrive in. Telling them their derma stamp is delayed would be
       confusing at best and untrue at worst, on the checkout click of all
       moments.

       So the test is the stamp itself, in a cart that also carries a
       subscription — which is exactly the set of people who were promised one.
       itemIsSerum is still used, but only as the fallback below: if the stamp
       is somehow missing from a subscription cart, a serum is good enough
       evidence that a gift was meant to be there.

       Previously this was `serum OR stamp` with no subscription test, which
       over-fired to every one-time serum buyer. */
    async function cartIsRelevant() {
      if (cartIsRelevantCache !== null) return cartIsRelevantCache;

      try {
        const cart = await fetchCart();
        const items = cart.items || [];

        if (!cartHasSubscription(cart)) {
          cartIsRelevantCache = false;
        } else {
          cartIsRelevantCache =
            items.some(itemIsDermaStamp) || items.some(itemIsSerum);
        }
      } catch (error) {
        /* Cart unreadable. Showing the notice to someone who did not need it is
           a moment's confusion; withholding it from someone who did means a
           delayed gift they were never warned about. Fail toward telling them. */
        cartIsRelevantCache = true;
      }

      return cartIsRelevantCache;
    }

    function invalidateCartCache() {
      cartIsRelevantCache = null;
    }

    function getCheckoutAction(trigger) {
      if (trigger && trigger.tagName === 'A') {
        return { type: 'link', href: trigger.href };
      }

      const form =
        (trigger && trigger.form) ||
        (trigger && trigger.getAttribute('form')
          ? document.getElementById(trigger.getAttribute('form'))
          : trigger && trigger.closest('form'));

      if (form) {
        return { type: 'form', form, submitter: trigger };
      }

      return { type: 'link', href: '/checkout' };
    }

    function proceedToCheckout(action) {
      window.__dermaStampNoticeBypass = true;
      closeAllCartDrawers();

      if (action.type === 'form') {
        if (typeof action.form.requestSubmit === 'function') {
          action.form.requestSubmit(action.submitter || undefined);
        } else {
          action.form.submit();
        }
      } else if (action.href) {
        window.location.assign(action.href);
      }

      window.setTimeout(() => {
        window.__dermaStampNoticeBypass = false;
      }, 250);
    }

    function showModal(trigger, action) {
      const modal = document.getElementById('DermaStampNoticeModal');
      if (!modal || typeof modal.show !== 'function') {
        proceedToCheckout(action);
        return;
      }

      pendingCheckout = action;
      closeAllCartDrawers();

      window.requestAnimationFrame(function () {
        window.setTimeout(function () {
          document.body.classList.add('derma-stamp-notice-open');
          modal.show(trigger || document.body);
        }, 160);
      });
    }

    function hideModal(modal) {
      document.body.classList.remove('derma-stamp-notice-open');
      if (modal && typeof modal.hide === 'function') {
        modal.hide();
      }
    }

    async function promptDermaStampNotice(trigger, action, browserEvent) {
      const isRelevant = await cartIsRelevant();

      if (!isRelevant) {
        return false;
      }

      if (browserEvent) {
        browserEvent.preventDefault();
        browserEvent.stopPropagation();
        if (typeof browserEvent.stopImmediatePropagation === 'function') {
          browserEvent.stopImmediatePropagation();
        }
      }

      showModal(trigger, action);
      return true;
    }

    window.dermaStampNoticePromptIfNeeded = async function (action) {
      if (window.__dermaStampNoticeBypass || !isActive()) return false;
      return promptDermaStampNotice(document.body, action, null);
    };

    async function handleCheckoutAttempt(event, trigger) {
      if (
        window.__dermaStampNoticeBypass ||
        window.__checkoutNoticeIntercepted ||
        !isActive() ||
        upcartCheckoutHandled
      ) {
        return;
      }

      if (packagingNoticeWillHandleCheckout()) {
        const isRelevant = await cartIsRelevant();
        if (isRelevant) return;
      }

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      window.__checkoutNoticeIntercepted = true;

      const action = getCheckoutAction(trigger);
      const intercepted = await promptDermaStampNotice(trigger, action, null);

      if (!intercepted) {
        window.__checkoutNoticeIntercepted = false;
        proceedToCheckout(action);
      }
    }

    async function maybeInterceptCheckoutUrl(url) {
      if (window.__dermaStampNoticeBypass || !isActive()) return false;
      if (pendingCheckout) return true;
      if (!url || !String(url).includes('/checkout')) return false;

      if (packagingNoticeWillHandleCheckout()) {
        const isRelevant = await cartIsRelevant();
        if (isRelevant) return false;
      }

      const isRelevant = await cartIsRelevant();
      if (!isRelevant) return false;

      window.__checkoutNoticeIntercepted = true;
      showModal(document.body, { type: 'link', href: url });
      return true;
    }

    function registerUpcartIntegration() {
      if (window.__dermaStampNoticeUpcartRegistered) return;
      if (typeof window.upcartSubscribeCheckoutClicked !== 'function') return;

      window.__dermaStampNoticeUpcartRegistered = true;

      window.upcartSubscribeCheckoutClicked(function (payload) {
        if (window.__dermaStampNoticeBypass || !isActive()) return;
        if (window.__checkoutNoticeIntercepted) return;

        upcartCheckoutHandled = true;
        window.setTimeout(function () {
          upcartCheckoutHandled = false;
        }, 500);

        const browserEvent = payload ? payload.event : undefined;
        const action = { type: 'link', href: '/checkout' };

        if (packagingNoticeWillHandleCheckout()) {
          cartIsRelevant().then(function (isRelevant) {
            if (isRelevant) return;
            window.__checkoutNoticeIntercepted = true;
            promptDermaStampNotice(document.body, action, browserEvent);
          });
          return;
        }

        window.__checkoutNoticeIntercepted = true;
        promptDermaStampNotice(document.body, action, browserEvent);
      });
    }

    function waitForUpcartApi(attempts) {
      registerUpcartIntegration();
      if (!window.__dermaStampNoticeUpcartRegistered && attempts < 50) {
        window.setTimeout(function () {
          waitForUpcartApi(attempts + 1);
        }, 200);
      }
    }

    document.addEventListener(
      'click',
      function (event) {
        const trigger = getCheckoutTrigger(event);
        if (!trigger) return;
        handleCheckoutAttempt(event, trigger);
      },
      true,
    );

    document.addEventListener(
      'submit',
      function (event) {
        if (window.__dermaStampNoticeBypass || !isActive()) return;
        if (window.__checkoutNoticeIntercepted) return;

        const form = event.target;
        if (!form || form.id !== 'cart') return;

        const submitter = event.submitter;
        if (
          !submitter ||
          (submitter.name !== 'checkout' &&
            !submitter.classList.contains('cart__checkout-button'))
        ) {
          return;
        }

        handleCheckoutAttempt(event, submitter);
      },
      true,
    );

    const previousAssign = window.location.assign.bind(window.location);
    const previousReplace = window.location.replace.bind(window.location);

    window.location.assign = function (url) {
      maybeInterceptCheckoutUrl(url).then(function (intercepted) {
        if (!intercepted) previousAssign(url);
      });
    };

    window.location.replace = function (url) {
      maybeInterceptCheckoutUrl(url).then(function (intercepted) {
        if (!intercepted) previousReplace(url);
      });
    };

    document.addEventListener('cart:updated', invalidateCartCache);
    document.addEventListener('cart:change', invalidateCartCache);
    document.addEventListener('ajaxCart:updated', invalidateCartCache);

    const modal = document.getElementById('DermaStampNoticeModal');
    const continueButton = document.getElementById(
      'DermaStampNoticeContinueCheckout',
    );
    const closeButton = document.getElementById('ModalClose-derma-stamp-notice');

    function clearPendingCheckout() {
      pendingCheckout = null;
      window.__checkoutNoticeIntercepted = false;
    }

    if (modal && continueButton) {
      continueButton.addEventListener('click', function () {
        const action = pendingCheckout || { type: 'link', href: '/checkout' };
        pendingCheckout = null;
        window.__checkoutNoticeIntercepted = false;
        hideModal(modal);
        window.setTimeout(function () {
          proceedToCheckout(action);
        }, 120);
      });
    }

    if (modal && closeButton) {
      closeButton.addEventListener('click', function () {
        clearPendingCheckout();
        hideModal(modal);
      });
    }

    if (modal && modal.addEventListener) {
      modal.addEventListener('keyup', function (event) {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') {
          clearPendingCheckout();
          hideModal(modal);
        }
      });
    }

    waitForUpcartApi(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
